import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { useViewport } from '@sbt-web/hooks';
import { FilterURI } from '@sbt-web/network/types';
import { Button, FormGroup, FullModal, Toggle } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { updateUrgent } from '@/reducers/search';
import { urgentLabel } from '@/tools/search/values';
import { InfoBadge } from '../InfoBadge';
import { NewBadge } from '../NewBadge';
import { FilterLabel } from '../common/FilterLabel';
import commonClasses from '../common/styles.module.scss';
import ownClasses from './urgent.module.scss';
type StateProps = {
  includeUrgent: boolean;
};
type OwnProps = {
  trackSearchConversion: () => void;
};
type DispatchProps = {
  updateUrgent: (includeUrgent: boolean) => void;
};
type Props = StateProps & DispatchProps & OwnProps;
const UrgentComponent = t0 => {
  const $ = _c(25);
  const {
    includeUrgent,
    updateUrgent,
    trackSearchConversion
  } = t0;
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "Urgente",
      text: "Solo annunci urgenti",
      description: "Visualizza gli annunci etichettati come \"Urgente\" dai venditori che hanno necessit\xE0 di concludere l'affare in breve tempo.",
      isNew: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const filterContent = t1;
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  let t2;
  if ($[1] !== trackSearchConversion || $[2] !== updateUrgent) {
    t2 = isSelected => {
      trackSearchConversion();
      return updateUrgent(isSelected);
    };
    $[1] = trackSearchConversion;
    $[2] = updateUrgent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSelection = t2;
  let t3;
  if ($[4] !== isMobile) {
    t3 = !isMobile && <InfoBadge onClick={() => setIsHelpModalOpen(true)} label={filterContent.label} />;
    $[4] = isMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isMobile) {
    t4 = isMobile && filterContent.isNew ? <NewBadge /> : null;
    $[6] = isMobile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isHelpModalOpen || $[9] !== isMobile) {
    t5 = !isMobile ? <FullModal open={isHelpModalOpen} title={filterContent.label} onClose={() => setIsHelpModalOpen(false)} actions={[<Button key="closer" design="solid" onClick={() => setIsHelpModalOpen(false)}>Ok, ho capito</Button>]}><p className={ownClasses["modal-max-w"]}>{filterContent.description}</p></FullModal> : null;
    $[8] = isHelpModalOpen;
    $[9] = isMobile;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <FilterLabel showBadgeNew={false} extraContent={<>{t3}{t4}{t5}</>}>{filterContent.label}</FilterLabel>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [commonClasses["custom-toggle"]];
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleSelection || $[17] !== includeUrgent) {
    t8 = <Toggle name={FilterURI.ItemUrgent} checked={includeUrgent} onInputChange={handleSelection} spaceBetweenElements={true} classes={t7}>{urgentLabel}</Toggle>;
    $[16] = handleSelection;
    $[17] = includeUrgent;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isMobile) {
    t9 = isMobile && <p className={classnames("body-text", "book", "small", commonClasses["mobile-help-txt"])}>{filterContent.description}</p>;
    $[19] = isMobile;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = <FormGroup>{t6}{t8}{t9}</FormGroup>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
const UrgentSelector = connect<StateProps, DispatchProps, OwnProps, RootState>((state, ownProps) => ({
  includeUrgent: state.search.includeUrgent,
  trackSearchConversion: ownProps.trackSearchConversion
}), dispatch => ({
  updateUrgent: (isActive: boolean) => dispatch(updateUrgent(isActive))
}))(UrgentComponent);
export default UrgentSelector;
export { UrgentComponent };